import { render, staticRenderFns } from "./index.vue?vue&type=template&id=71675410&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=71675410&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71675410",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\www\\mer\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('71675410')) {
      api.createRecord('71675410', component.options)
    } else {
      api.reload('71675410', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=71675410&scoped=true", function () {
      api.rerender('71675410', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/distribution/alliance/distribution-product/index.vue"
export default component.exports